import { Box, Button, Typography } from "@mui/material";
import { Icon } from "@iconify/react";
export const crmViewTableHeader=(navigate,fromDate,toDate) => [
    {
      field: "sl_no",
      headerName: "slNo",
      width: 20,
    },
    {
      field: "croName",
      headerName: "CRO Name",
      width: 300,
    },
    {
      field: "assignedStudents",
      headerName: "Total Students",
      width: 150,
    },
    // {
    //   field: "assignedStudentsCount",
    //   headerName: "Assigned Students",
    //   width: 150,
    // },
    // {
    //   field: "unAssignedStudentsCount",
    //   headerName: "Un Assigned Students",
    //   width: 200,
    // },
    {
        field: "totalCourses",
        headerName: "Total Courses",
        width: 150,
      },
    {
      field: "activeCoursesCount",
      headerName: "Active Courses",
      width: 150,
    },
    {
        field: "inActiveCoursesCount",
        headerName: "In Active Courses",
        width: 150,
      },
     
      {
        field: "temporarilyInactiveCoursesCount",
        headerName: "Temporarly  In Active",
        width: 150,
      },
      {
        field: "action",
        headerName: "Action",
        width: 150,
        renderCell: (params) => {
          return (
            <Button
              sx={{
                p:'7px',
                background:
              "linear-gradient(135deg, #2f72b3, #1e65ab6e)",
                color: "#fff",
                "&:hover": {
                  background:
                  "linear-gradient(135deg,rgb(7, 71, 136),rgba(4, 19, 34, 0.43))",
                },
              }}
              onClick={() => navigate(`/my-workspace/CRO-View/?id=${params?.row?.croId}${
                fromDate ? `&fromDate=${fromDate}` : ""
              }${toDate ? `&toDate=${toDate}` : ""}`)}
              size="small"
              variant="outlined"
            >
              <Box sx={{display:'flex',alignItems:'center',justifyContent:'center',gap:1}}>
                <Typography variant="overline">CRO Report</Typography>
                <Icon icon="ep:d-arrow-right" width="15" height="15" color="black" />
              </Box>
            </Button>
          );
        },
      },
    
  ];
  